import { Font } from '@react-pdf/renderer';
import React from 'react';
import AuthProvider from './providers/AuthProvider';
import './scss/index.scss';
import createHypenator from 'hyphen';
import patterns from 'hyphen/patterns/es';
import SecureRouter from 'SecureRouter';
import dayjs from 'libs/dayjs';
import { App as AntdApp } from 'antd';

import { TenantDataProvider } from 'providers/Tenant/TenantDataProvider';
import { TenantBrandingProvider } from 'providers/Tenant/TenantBrandingProvider';
import { ClientTabsProvider } from 'providers/ClientTabs/ClientTabsProvider';
import ThemedApp from 'components/ThemedApp';
import { ModalProvider } from './common/providers/ModalProvider';

const text = createHypenator(patterns, {
  hyphenChar: '-',
  minWordLength: 0,
});

Font.registerHyphenationCallback((word) => {
  if (word.includes(' ')) {
    return [word];
  }
  return text(word).split('-');
});

function App() {
  return (
    <AntdApp>
      <TenantBrandingProvider>
        <ThemedApp>
          <ModalProvider>
            <AuthProvider>
              <TenantDataProvider>
                <ClientTabsProvider>
                  <SecureRouter />
                </ClientTabsProvider>
              </TenantDataProvider>
            </AuthProvider>
          </ModalProvider>
        </ThemedApp>
      </TenantBrandingProvider>
    </AntdApp>
  );
}

export default App;
